import { useEffect, useState } from 'react';
import { IconButton, Skeleton } from '@mui/material';
import { Close } from '@mui/icons-material';
import pdfToImage from '../utils/pdf-to-img';

const PdfImageDisplay = ({ file, isLoading }) => {
  const [showFullImage, setShowFullImage] = useState(false);
  const [imgSource, setImgSource] = useState(null);

  useEffect(() => {
    setImgSource(null);
    if (file && !isLoading) {
      pdfToImage(file).then(setImgSource);
    }
  }, [file, isLoading]);

  const onClick = () => {
    if (!isLoading) {
      setShowFullImage(true);
    }
  }

  return (
    <>
      <div className="pdf-image-display bg-light" onClick={onClick}>
        { (isLoading || !imgSource)
          ? <LoadingState />
          : <img src={imgSource} alt="Expense Preview" data-testid="pdf-page-small"/>
        }
        <div className="pdf-image-display__overlay"/>
      </div>
      { showFullImage && (
        <div className="overlay pdf-image-display__full-image">
          <img src={imgSource} alt="Expense" data-testid="pdf-page-full" />
          <IconButton className="pdf-image-display__close-button bg-light" size="large" onClick={() => setShowFullImage(false)} data-testid="close-button">
            <Close fontSize="large" />
          </IconButton>
        </div>
      )}
    </>
  );
};

const LoadingState = () => <>
  <Skeleton variant="rectangular" animation="wave" width="100%" height="100%" sx={{ bgcolor: 'grey.400' }} data-testid="loading-state"/>
</>;

export default PdfImageDisplay;
